// removed by extract-text-webpack-plugin
module.exports = {"main":"#1A2C5A","large_desktop":"only screen and (min-width: 1201px)","desktop":"only screen and (min-width: 1025px) and (max-width: 1200px)","tablet":"only screen and (min-width: 768px) and (max-width: 1024px)","mobile":"only screen and (max-width: 767px)","ourOffices":"ourOffices__3EXiT","offices":"offices__3meVS","office":"office__2lbyt","officeSelected":"officeSelected__w_l39"};


//////////////////
// WEBPACK FOOTER
// ./components/OurOffices/style.css
// module id = 9b7G
// module chunks = 0